import { Row } from 'antd';
import React from 'react';
import SettingPerAccount from './SettingPerAccount';
import SettingPerDevice from './SettingPerDevice';
import SettingPerNamespace from './SettingPerNamespace';

const SettingTab = ({
  form,
  service,
  onFinishPerNamespace,
  initialPerNameSpace,
  checkUpdatePerNamespace,
  setCheckUpdatePerNamespace,
  dataPerNameTemp,
  listNotificationService,
  dataSelectNotificationEvent,
  onChangeEventNotification,
  keyTable,
  devicesActive,
  formExpand,
  onFinishPerDevice,
  initialPerDevice,
  checkUpdatePerDevice,
  setCheckUpdatePerDevice,
  setKeyTable,
  expKeys,
  setExpKeys,
  handleTableChangeActive,
  isLoadActiveLicense,
  accountsActive,
  formExpandAccount,
  onFinishPerAccount,
  initialPerAccount,
  checkUpdatePerAccount,
  setCheckUpdatePerAccount,
  expKeysAccount,
  setExpKeysAccount,
  handleTableChangeAccountActive,
  isLoadActiveLicenseAccount,
}) => {
  return (
    <Row gutter={16} style={{ marginLeft: '0px' }}>
      <SettingPerNamespace
        form={form}
        service={service}
        onFinishPerNamespace={onFinishPerNamespace}
        initialPerNameSpace={initialPerNameSpace}
        checkUpdatePerNamespace={checkUpdatePerNamespace}
        setCheckUpdatePerNamespace={setCheckUpdatePerNamespace}
        dataPerNameTemp={dataPerNameTemp}
        listNotificationService={listNotificationService}
        dataSelectNotificationEvent={dataSelectNotificationEvent}
        onChangeEventNotification={onChangeEventNotification}
      />
      <SettingPerDevice
        keyTable={keyTable}
        devicesActive={devicesActive}
        formExpand={formExpand}
        onFinishPerDevice={onFinishPerDevice}
        initialPerDevice={initialPerDevice}
        service={service}
        checkUpdatePerDevice={checkUpdatePerDevice}
        setCheckUpdatePerDevice={setCheckUpdatePerDevice}
        setKeyTable={setKeyTable}
        expKeys={expKeys}
        setExpKeys={setExpKeys}
        handleTableChangeActive={handleTableChangeActive}
        isLoadActiveLicense={isLoadActiveLicense}
      />
      <SettingPerAccount
        keyTable={keyTable}
        accountsActive={accountsActive}
        formExpandAccount={formExpandAccount}
        onFinishPerAccount={onFinishPerAccount}
        initialPerAccount={initialPerAccount}
        service={service}
        checkUpdatePerAccount={checkUpdatePerAccount}
        setCheckUpdatePerAccount={setCheckUpdatePerAccount}
        setKeyTable={setKeyTable}
        expKeysAccount={expKeysAccount}
        setExpKeysAccount={setExpKeysAccount}
        handleTableChangeAccountActive={handleTableChangeAccountActive}
        isLoadActiveLicenseAccount={isLoadActiveLicenseAccount}
      />
    </Row>
  );
};

export default SettingTab;
